import { Component, inject } from '@angular/core';
import { AuthenticationService } from '../../services/authentication.service';

@Component({
    selector: 'ukho-permissions-error',
    standalone: true,
    templateUrl: './permissions-error.component.html',
    styleUrls: ['./permissions-error.component.scss']
})
export class PermissionsErrorComponent {
  private readonly authenticationService = inject(AuthenticationService);

  public login(): void {
    this.authenticationService.login();
  }
}
